<template>
  <div class="view-files-list">
    <loading v-if="loadingRender || signingInProgress"></loading>

    <div v-if="ShowEmpty && !loadingRender" class="view-files-empty">
      <i
        class="fas fa-folder-open view-files-empty__icon"
        aria-hidden="true"
      ></i>
      <p class="view-files-empty__title">فایلی برای نمایش موجود نیست</p>
      <p class="view-files-empty__desc">
        در حال حاضر فرم یا فایلی روی سرور ثبت نشده است.
      </p>
    </div>

    <div v-else-if="!loadingRender" class="view-files-grid">
      <article
        v-for="(item, index) in Files"
        :key="item.id || index"
        class="view-files-card"
      >
        <div class="view-files-card__icon-wrap">
          <img
            class="view-files-card__icon"
            :src="ReturnIcone(item.filename)"
            :alt="item.filename"
          />
          <span class="view-files-card__ext">{{
            fileExtension(item.filename)
          }}</span>
        </div>

        <div class="view-files-card__body">
          <span class="view-files-card__category">{{
            fileCategory(item)
          }}</span>
          <h6 class="view-files-card__name" :title="item.filename">
            {{ item.filename }}
          </h6>
        </div>

        <div class="view-files-card__actions">
          <a
            :download="item.filename"
            title="دانلود فایل"
            :href="'data:application/octet-stream;base64,' + item.binary"
            class="btn btn-success btn-sm view-files-card__btn"
          >
            <i class="fas fa-download ml-1" aria-hidden="true"></i>
            دریافت فایل
          </a>

          <button
            v-if="canSign(item)"
            type="button"
            :disabled="signingInProgress"
            @click="GetfileEmza(item)"
            class="btn btn-outline-secondary btn-sm view-files-card__btn"
            title="امضای فایل"
          >
            <i class="fas fa-signature ml-1" aria-hidden="true"></i>
            امضا
          </button>

          <button
            v-if="$session.get('IsRahbar')"
            type="button"
            @click="Delete(item.id)"
            class="btn btn-outline-danger btn-sm view-files-card__btn"
            title="حذف فایل"
          >
            <i class="fas fa-trash" aria-hidden="true"></i>
          </button>
        </div>
      </article>
    </div>
  </div>
</template>
<script>
import loading from "../../Tools/NetPa/Loading.vue";

export default {
  props: ["IsAdmin"],
  components: {
    loading,
  },
  data() {
    return {
      Tablekey: 0,
      ShowEmpty: false,
      Files: [],
      IsEmza: false,
      loadingRender: false,
      signingInProgress: false,
    };
  },
  methods: {
    GetFile() {
      this.ShowEmpty = false;
      this.loadingRender = true;

      var dataAxios = {
        Method: "POST",
        Action: "Uploader/GetFile",
        ArryfildValue: {
          MasterId: this.$session.get("CustCode"),
          tableName: "ExtraForms",
        },
      };
      this.$PostData(dataAxios).then((result) => {
        this.loadingRender = false;

        this.file = result.data;
        this.Tablekey++;
        if (result.data == null || result.data.length == 0) {
          this.ShowEmpty = true;
        } else {
          this.Files = result.data;
        }
      });
    },
    showEmzaError() {
      this.$mySweetDefaultTost(
        "عملیات ناموفق",
        "خطایی رخ داد. لطفا در ساعات آینده مجددا تلاش کنید",
        "error",
        5000,
      );
    },
    async downloadSignedPdf(base64Data, contentType, fileName) {
      const type = contentType || "application/octet-stream";
      const cleanBase64 = String(base64Data).replace(/\s/g, "");
      let blob;

      if (typeof Uint8Array.fromBase64 === "function") {
        blob = new Blob([Uint8Array.fromBase64(cleanBase64)], { type });
      } else {
        const response = await fetch(`data:${type};base64,${cleanBase64}`);
        blob = await response.blob();
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName || "downloaded-file";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
    GetfileEmza(item) {
      if (this.signingInProgress) return;

      const userInfo = this.$session.get("UserInfoNetPa");
      if (!item || !item.id || !userInfo || !userInfo.codeMeli || !userInfo.mobile) {
        this.showEmzaError();
        return;
      }

      this.signingInProgress = true;
      this.$PostData({
        Method: "POST",
        Action: "Uploader/GetfileEmza",
        ArryfildValue: {
          FileId: item.id,
          CustCode: this.$session.get("CustCode"),
          CodeMeli: userInfo.codeMeli,
          Mobile: userInfo.mobile,
        },
      })
        .then((result) => {
          if (!result) {
            this.showEmzaError();
            return;
          }

          if (result.status == "linkCreated") {
            const payload = result.data || result.Data;
            const gatewayLink =
              payload && (payload.gatewayLink || payload.GatewayLink);
            if (!gatewayLink) {
              this.showEmzaError();
              return;
            }
            window.location.href = gatewayLink;
            return;
          }

          if (result.status == "downLoadFile") {
            const base64Data = result.data || result.Data;
            if (!base64Data) {
              this.showEmzaError();
              return;
            }
            return this.downloadSignedPdf(
              base64Data,
              result.type || result.Type,
              item.filename,
            );
          }

          this.showEmzaError();
        })
        .catch(() => {
          this.showEmzaError();
        })
        .finally(() => {
          this.signingInProgress = false;
        });
    },
    Delete(id) {
      this.$SweetQustion(
        "درخواست حذف فایل",
        "از حذف فایل انتخابی خود اطمینان دارید ؟",
        "warning",
        "حــذف",
        "انصراف",
        id,
        this.ConfirmDelete,
        this.Cancel,
      );
    },
    ConfirmDelete(id) {
      var axios = {
        Method: "POST",
        Action: "Uploader/Delete",
        ArryfildValue: { Id: id },
      };
      this.$PostData(axios).then((result) => {
        this.$mySweetDefaultTost(result.title, result.msg, result.icon, 2000);
        this.GetFile();
      });
    },
    Cancel() {},
    canSign(item) {
      const grp = item.wwwtblcomboidgrp328;
      return grp == 100 || grp == 101 || grp == 102;
    },
    fileCategory(item) {
      const map = {
        100: "قرارداد عضویت",
        101: "قرارداد وام",
        102: "قرارداد (امضا)",
        181070513: "فرم جانبی",
      };
      return map[item.wwwtblcomboidgrp328] || "فایل";
    },
    fileExtension(name) {
      if (!name || name.indexOf(".") === -1) return "FILE";
      return name.split(".").pop().toUpperCase();
    },
    ReturnIcone(name) {
      var ex = name.split(".").pop().toLowerCase();
      if (["rar", "zip"].includes(ex)) {
        return "/Image/ZipFile.png";
      }
      if (["pdf"].includes(ex)) {
        return "/Image/PDFFileEx.png";
      }
      if (["png", "jpg", "jpeg"].includes(ex)) {
        return "/Image/Image.png";
      }
      return "/Image/PDFFileEx.png";
    },
  },
  created() {
    this.GetFile();
  },
};
</script>
<style scoped>
.view-files-list {
  width: 100%;
  padding: 0.75rem 0 0.25rem;
}

.view-files-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 1rem;
}

.view-files-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1rem;
  border: 1px solid #e8ecf1;
  border-radius: 12px;
  background: #fff;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
}

.view-files-card:hover {
  border-color: #d5dce6;
  box-shadow: 0 4px 16px rgba(42, 63, 84, 0.08);
}

.view-files-card__icon-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 88px;
  margin-bottom: 0.75rem;
  padding: 0.75rem;
  border-radius: 10px;
  background: #f8f9fb;
}

.view-files-card__icon {
  max-width: 56px;
  max-height: 56px;
  object-fit: contain;
}

.view-files-card__ext {
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  padding: 0.15rem 0.45rem;
  font-size: 0.7rem;
  font-weight: 600;
  color: #6c757d;
  background: #fff;
  border: 1px solid #e8ecf1;
  border-radius: 4px;
}

.view-files-card__body {
  flex: 1 1 auto;
  min-width: 0;
  margin-bottom: 0.75rem;
}

.view-files-card__category {
  display: inline-block;
  margin-bottom: 0.35rem;
  padding: 0.15rem 0.5rem;
  font-size: 0.75rem;
  color: #495057;
  background: #f1f3f5;
  border-radius: 999px;
}

.view-files-card__name {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.5;
  color: #212529;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.view-files-card__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: auto;
  padding-top: 0.75rem;
  border-top: 1px solid #f0f2f5;
}

.view-files-card__btn {
  flex: 1 1 auto;
  min-width: fit-content;
}

.view-files-empty {
  padding: 2.5rem 1rem;
  text-align: center;
  border: 1px dashed #dee2e6;
  border-radius: 12px;
  background: #fafbfc;
}

.view-files-empty__icon {
  font-size: 2rem;
  color: #adb5bd;
  margin-bottom: 0.75rem;
}

.view-files-empty__title {
  margin: 0 0 0.35rem;
  font-size: 1rem;
  font-weight: 600;
  color: #495057;
}

.view-files-empty__desc {
  margin: 0;
  font-size: 0.875rem;
  color: #6c757d;
}

@media (max-width: 575px) {
  .view-files-grid {
    grid-template-columns: 1fr;
  }

  .view-files-card__actions {
    flex-direction: column;
  }

  .view-files-card__btn {
    width: 100%;
  }
}
</style>
